import { breakpoints } from './theme';

// Medya sorguları için yardımcı fonksiyonlar
export const media = {
  xs: `@media (max-width: ${breakpoints.xs})`,
  sm: `@media (max-width: ${breakpoints.sm})`,
  md: `@media (max-width: ${breakpoints.md})`,
  lg: `@media (max-width: ${breakpoints.lg})`,
  xl: `@media (max-width: ${breakpoints.xl})`,
  '2xl': `@media (max-width: ${breakpoints['2xl']})`,
  
  // Min-width sorguları
  up: {
    xs: `@media (min-width: ${breakpoints.xs})`,
    sm: `@media (min-width: ${breakpoints.sm})`,
    md: `@media (min-width: ${breakpoints.md})`,
    lg: `@media (min-width: ${breakpoints.lg})`,
    xl: `@media (min-width: ${breakpoints.xl})`,
    '2xl': `@media (min-width: ${breakpoints['2xl']})`
  },
  
  // Özel aralık sorguları
  between: (start, end) => `@media (min-width: ${breakpoints[start]}) and (max-width: ${breakpoints[end]})`,
  
  // Yönlendirme sorguları
  landscape: '@media (orientation: landscape)',
  portrait: '@media (orientation: portrait)',
  
  // Özellik sorguları
  dark: '@media (prefers-color-scheme: dark)',
  light: '@media (prefers-color-scheme: light)',
  motion: '@media (prefers-reduced-motion: no-preference)',
  noMotion: '@media (prefers-reduced-motion: reduce)',
  
  // Cihaz tipi sorguları
  hover: '@media (hover: hover)',
  touch: '@media (hover: none) and (pointer: coarse)',
  
  // Retina ekran sorgusu
  retina: '@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)'
}; 